






import {Vue, Component, Prop} from 'vue-property-decorator';
import EmbeddedFile from "@/components/common/EmbeddedFile.vue";
import PayrollFileDTO from "@/dto/payroll/PayrollFileDTO";

@Component({
	components: {EmbeddedFile}
})
export default class PatriotPaystubView extends Vue {
	@Prop()
	private report!: PayrollFileDTO
}
